module.exports = __webpack_public_path__ + "static/img/shuttle-bus.4a139444.svg";